import Breadcrumb from 'components/Common/Breadcrumb';
import React, { useEffect, useState } from 'react'
import { Container, CardBody, Card, UncontrolledAccordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap"

const data = [
    { id: 1, title: "GoCardless", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 2, title: "Lead", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 3, title: "Practice", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 4, title: "TaskReport", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 5, title: "Pages", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 6, title: "EmailList", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 7, title: "EmailTemplate", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 8, title: "Doc", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 9, title: "Task", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 10, title: "Clients", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 11, title: "Users", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 12, title: "Status", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
    { id: 13, title: "Document", checkboxes: ["Option 1", "Option 2", "Option 3", "Option 4"] },
];

const AccessPermission = () => {

    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});

    const handleCheckboxChange = (id, option) => {
        setSelectedCheckboxes((prev) => {
            const currentSelections = prev[id] || [];
            if (currentSelections.includes(option)) {
                return { ...prev, [id]: currentSelections.filter((item) => item !== option) };
            } else {
                return { ...prev, [id]: [...currentSelections, option] };
            }
        });
    };

    useEffect(() => {
        document.title = "Access Permission | Peacock Accountants Limited";
    }, [])

    return (
        <div>
            <div className="page-content mb-5">
                <Container fluid>
                    <Breadcrumb title={"Dashboard"} breadcrumbItem={"Access Permission"} />

                    <Card>
                        
                        <CardBody>
                            <div className='access_permission'>
                                <UncontrolledAccordion defaultOpen="1">
                                    {data.map((item) => (
                                        <AccordionItem key={item.id}>
                                            <AccordionHeader targetId={String(item.id)}>
                                                {item.title}
                                            </AccordionHeader>
                                            <AccordionBody accordionId={String(item.id)}>
                                                <div>
                                                    {item.checkboxes.map((option) => (
                                                        <div key={option}>
                                                            <label className='d-flex align-items-center'>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={
                                                                        selectedCheckboxes[item.id]?.includes(option) || false
                                                                    }
                                                                    onChange={() => handleCheckboxChange(item.id, option)}
                                                                    className='fs-5 me-3'
                                                                />
                                                                {option}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </AccordionBody>
                                        </AccordionItem>
                                    ))}
                                    {/* <AccordionItem>
                                    <AccordionHeader targetId="1">
                                        Accordion Item 1
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1">
                                        <strong>
                                            This is the first item's accordion body.
                                        </strong>
                                        You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the{' '}
                                        <code>
                                            .accordion-body
                                        </code>
                                        , though the transition does limit overflow.
                                    </AccordionBody>
                                </AccordionItem> */}
                                </UncontrolledAccordion>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </div>
    )
}

export default AccessPermission